import { ROLE_BOM } from "@/lib/utils";
import { OwnerDashboard } from "./OwnerDashboard";
import useDashboard from "./useDashboard";
import { Dialog, Loader } from "@/components";
import { Button } from "@/components/ui";
import moment from "moment";
import { BomDashboard } from "./BomDashboard";
import { useEffect, useRef, useState } from "react";

const Dashboard = () => {
  const { currentRole, isContractLoading, contract, contentRichText, openTncDialog, isBomCommunityLoading,
    setOpenTncDialog, onDisAgree, onAgree, isUpdatePending } = useDashboard();
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const scrollCleanup = useRef<(() => void) | null>(null);

  useEffect(() => {
    setHasScrolledToBottom(false);
    return () => scrollCleanup.current?.();
  }, [openTncDialog, contentRichText]);

  const onTncContentLoad = (event: React.SyntheticEvent<HTMLIFrameElement>) => {
    scrollCleanup.current?.();

    const document = event.currentTarget.contentDocument;
    const scrollElement = document?.scrollingElement;
    if (!document || !scrollElement) return;

    const updateScrollState = (event?: Event) => {
      const eventTarget = event?.target as HTMLElement | null;
      const scrollContainer =
        eventTarget && eventTarget.scrollHeight > eventTarget.clientHeight + 1
          ? eventTarget
          : [scrollElement, document.documentElement, document.body].find(
              (element) => element.scrollHeight > element.clientHeight + 1
            );

      if (!scrollContainer) {
        setHasScrolledToBottom(true);
        return;
      }

      const scrollTop = Math.max(
        scrollContainer.scrollTop,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );
      setHasScrolledToBottom(
        scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 2
      );
    };

    document.addEventListener("scroll", updateScrollState, true);
    const frameWindow = event.currentTarget.contentWindow;
    frameWindow?.addEventListener("scroll", updateScrollState);
    scrollCleanup.current = () => {
      document.removeEventListener("scroll", updateScrollState, true);
      frameWindow?.removeEventListener("scroll", updateScrollState);
    };
    updateScrollState();
  };

  return (
    <div className="p-4 md:p-6">
      {isContractLoading || isBomCommunityLoading ? <Loader /> : 
        currentRole == ROLE_BOM ? <BomDashboard /> : <OwnerDashboard />
      }
      <Dialog
        open={openTncDialog}
        setOpen={setOpenTncDialog}
        title={
          <div className="text-[22px] bg-primary text-white absolute w-full top-0 left-0 p-4 rounded-[10px] !font-[300]">Required Version: V{contract?.data?.versionNo?.toString() || ""} {contract?.data?.effectiveDate ? `(Effective Date: ${moment(contract?.data?.effectiveDate).format('MM/DD/YYYY')})` : ''}</div>
        }
        contentClassName="lg:!max-w-[1200px] lg:!w-[1200px] lg:!max-h-[80vh] lg:!h-[80vh] py-[50px] overflow-hidden"
        bodyClassName="!my-0 !max-h-none !overflow-hidden !p-0 lg:!h-[calc(80vh-100px)]"
        hideFooter
        hideClose
      >
        <iframe
          srcDoc={contentRichText}
          onLoad={onTncContentLoad}
          className="h-[60vh] w-full border-0 overflow-hidden lg:h-full"
        />
        <div className="flex flex-row items-center justify-end gap-[10px] mt-[10px] fixed bottom-[20px] right-[20px] w-full">
          <Button variant="secondary" onClick={onDisAgree} disabled={isUpdatePending}>Decline</Button>
          <Button onClick={onAgree} disabled={isUpdatePending || !hasScrolledToBottom}>Accept</Button>
        </div>
      </Dialog>
    </div>
  );
};

export default Dashboard;
